import { observable, makeObservable } from 'mobx'
import { Model } from 'infra/model'
import { ContactInfoDto } from './dtos'

export class ContactInfo extends Model<ContactInfoDto, ContactInfo> {
  @observable
  email = ''

  @observable
  phoneNumber = ''

  @observable
  addressLine1 = ''

  @observable
  addressLine2 = ''

  @observable
  city = ''

  @observable
  region = ''

  @observable
  postalCode = ''

  @observable
  country = ''

  constructor() {
    super()
    makeObservable(this)
  }

  parse(attrs: ContactInfoDto): Partial<ContactInfo> {
    return {
      email: attrs.email,
      phoneNumber: attrs.phoneNumber,
      addressLine1: attrs.address?.addressLine1,
      addressLine2: attrs.address?.addressLine2,
      city: attrs.address?.city,
      postalCode: attrs.address?.postalCode,
      region: attrs.address?.region,
      country: attrs.address?.country,
    }
  }
}
